import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ComponentSize, DEFAULT_COMPONENT_SIZE } from '@examdojo/core/model';
import { SingleSelectComponent } from '@examdojo/core/select';
import { UserRole } from '@examdojo/models/user';
@Component({
  selector: 'exam-admin-user-detail-role-selector',
  template: `
    <dojo-single-select
      [formCtrl]="formCtrl()"
      [optionLabel]="'label'"
      [optionValue]="'value'"
      [options]="options()"
      [label]="label()"
      [size]="size()"
    />
  `,
  imports: [SingleSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminUserDetailRoleSelectorComponent {
  readonly formCtrl = input.required<FormControl<UserRole>>();
  readonly label = input<string>();
  readonly size = input<ComponentSize>(DEFAULT_COMPONENT_SIZE);

  readonly roleOptions = input<UserRole[]>(['ADMIN', 'CONTRIBUTOR']);

  readonly options = computed(() => {
    return this.roleOptions().map((role) => ({
      value: role,
      label: role,
    }));
  });
}
